import React, { useState, useEffect } from "react";
import Grid from "@mui/material/Grid2";
import { fetchData } from "../../firebase/database";
import { useAuth } from "../../contexts/authContext";

import "./Home.css";
import Navbar from "../../components/navbar/Navbar";
import BatteryCellVoltage from "../../components/batteryCellVoltage/BatteryCellVoltage";
import Footer from "../../components/footer/Footer";
import LineChart from "../../components/chart/Chart";

const Home = () => {
  const { currentUser } = useAuth();

  const [lastUpdateTime, setLastUpdateTime] = useState("");
  const [voltage, setVoltage] = useState(0);
  const [chargingCurrent, setChargingCurrent] = useState(0);
  const [capacity, setCapacity] = useState(0);
  const [temperature, setTemperature] = useState(0);
  const [cellVoltages, setCellVoltages] = useState([]);

  useEffect(() => {
    if (currentUser) {
      fetchData(
        setCellVoltages,
        setLastUpdateTime,
        setVoltage,
        setChargingCurrent,
        setCapacity,
        setTemperature,
        currentUser
      );
    }
  }, [currentUser]);

  return (
    <>
      {/* Navbar */}
      <Navbar />

      {/* Main Content Wrapper */}
      <div className="main-content">
        {/* Welcome Section */}
        <div className="welcome-container">
          <h1>Welcome to the Dashboard</h1>
          <p className="last-update">Last updated on: {lastUpdateTime}</p>
        </div>

        {/* Main Container */}
        <div className="main-container">
          <Grid container spacing={2}>
            {/* Voltage */}
            <Grid size={{ xs: 12, md: 6, lg: 3 }}>
              <div className="stat-box">
                <LineChart chartType="voltage" value={voltage}></LineChart>
              </div>
            </Grid>

            {/* Capacity */}
            <Grid size={{ xs: 12, md: 6, lg: 3 }}>
              <div className="stat-box">
                {" "}
                <LineChart chartType="current" value={chargingCurrent}></LineChart>
              </div>
            </Grid>

            {/* Current */}
            <Grid size={{ xs: 12, md: 6, lg: 3 }}>
              <div className="stat-box">
                {" "}
                <LineChart chartType="capacity" value={capacity}></LineChart>
              </div>
            </Grid>

            {/* Temperature */}
            <Grid size={{ xs: 12, md: 6, lg: 3 }}>
              <div className="stat-box">
                <LineChart chartType="temperature" value={temperature}></LineChart>
              </div>
            </Grid>
          </Grid>

          {/* Cell Voltage */}
          <BatteryCellVoltage cellVoltages={cellVoltages} />
        </div>
      </div>

      {/* Footer */}
      <Footer />
    </>
  );
};

export default Home;
